import type { ResumoGmud } from '../../../types/gmud'
import { CartaoDeGmud } from './CartaoDeGmud'
import { DESCRICAO_DA_LISTA } from './colunas'
import { TabelaDeGmuds } from './TabelaDeGmuds'

/**
 * A mesma página de resultados em duas formas: tabela no computador, cartões no telefone.
 *
 * A troca é por CSS e não por `matchMedia`, e isso é escolha: medir a largura em JavaScript faz
 * a página montar com a forma errada e trocar depois que o React roda — o cartão pisca e vira
 * tabela, ou a tabela pisca e vira cartão, em toda visita. Com `hidden`, o navegador já entrega
 * a forma certa no primeiro quadro, e o que está escondido some também da árvore de
 * acessibilidade: quem usa leitor de tela ouve uma lista, não as duas.
 *
 * @param props as linhas da página corrente
 * @returns a tabela e os cartões, um visível de cada vez
 */
export function ListagemDeGmuds({ itens }: { itens: ResumoGmud[] }) {
  return (
    <>
      <div className="hidden sm:block">
        <TabelaDeGmuds itens={itens} />
      </div>

      <ul aria-label={DESCRICAO_DA_LISTA} className="space-y-3 sm:hidden">
        {itens.map((gmud) => (
          <CartaoDeGmud key={gmud.id} gmud={gmud} />
        ))}
      </ul>
    </>
  )
}
